import { Bone } from "@/components/Bone";
import { BoneLine, BonePanel, BoneTitle, Skeleton } from "@/components/PageSkeleton";

import styles from "./CalculationScreen.module.css";

/** The region's name for a screen reader while the calculation loads. */
export const CALCULATION_LOADING = "Kalkulation wird geladen";

/**
 * The calculation in its own geometry while the Vorgang and its latest
 * calculation load (Task 10; UX review 26.10.2026, B-4), built from the
 * screen's classes: title, lede and meta line; the parameter bar; the live
 * line; the positions and the totals as panels. Under the frame that already
 * names the Vorgang — never a loading line.
 */
export function CalculationSkeleton() {
  return (
    <Skeleton label={CALCULATION_LOADING} className={styles.screen}>
      <div className={styles.head} aria-hidden="true">
        <BoneTitle width="7rem" />
        <BoneLine className={styles.lede} width="28rem" />
        <BoneLine className={styles.meta} width="16rem" />
      </div>
      <div className={styles.params} aria-hidden="true">
        {[0, 1, 2, 3, 4].map((field) => (
          <div key={field} className={styles.reading}>
            <BoneLine className="label" width="5rem" height="0.625rem" />
            <Bone height="2.5rem" />
            {/* The margin's formula under its field sets the bar's height. */}
            {field === 4 ? <BoneLine width="7rem" height="0.625rem" /> : null}
          </div>
        ))}
      </div>
      <p className={styles.live} aria-hidden="true" />
      <BonePanel head>
        {["100%", "100%", "100%", "100%", "100%", "60%"].map((width, row) => (
          <Bone key={row} width={width} height="1.25rem" />
        ))}
      </BonePanel>
      <BonePanel head>
        <Bone width="40%" height="1.5rem" />
        <Bone width="30%" />
      </BonePanel>
    </Skeleton>
  );
}
